import type { SpotifyEpisode } from '@/types/spotify.types';
import { formatDate } from '@/utils/formatDate';
import { Clock } from 'lucide-react';

interface PodcastCardProps {
  episode: SpotifyEpisode;
  background?: 'grey' | 'white';
}

function PodcastCard({ episode, background = 'grey' }: PodcastCardProps) {
  return (
    <article
      key={episode.id}
      className={`rounded-md border border-gray-300 p-4 py-3 flex gap-4 items-center ${background === 'white' ? 'bg-white' : 'bg-[#E4E4E440]'}`}
    >
      {episode.images?.[0] && (
        <img
          src={episode.images[0].url}
          alt={episode.name}
          className='w-20 h-20 object-cover rounded-md border border-gray-300'
        />
      )}

      <div className='flex flex-col justify-between min-h-[85%]'>
        <a
          target='_blank'
          rel='noopener noreferrer'
          href={episode.external_urls.spotify}
          className='hover:text-teal-600 hover:underline transition-all'
        >
          <h3 className='font-bold text-lg m-0 p-0 leading-5 tracking-tight line-clamp-3'>{episode.name}</h3>
        </a>
        <span className='text-sm text-gray-600 pt-1 flex items-center'>
          <Clock className='size-4 mr-2' />
          <p>{Math.floor(episode.duration_ms / 60000)}min</p>
          <span className='mx-1.5'>&middot;</span>
          <p>{formatDate(episode.release_date)}</p>
        </span>
      </div>

      <a
        target='_blank'
        rel='noopener noreferrer'
        href={episode.external_urls.spotify}
        className='hidden ml-auto hover:opacity-70 transition-opacity md:block'
      >
        <img src='./play-icon.svg' alt='Play icon' className='inline-block min-w-[44px] mr-1' />
      </a>
    </article>
  );
}

export default PodcastCard;
